import { Injectable } from '@angular/core';
import { SettingsRepository } from '@app/store';

@Injectable({
  providedIn: 'root',
})
export class PlannerOnBoardingService {
  public readonly showPlannerOnBoarding$ =
    this.settingsRepository.showPlannerOnBoarding$;

  private initialized = false;

  constructor(private readonly settingsRepository: SettingsRepository) {}

  public initialize(): void {
    if (this.initialized) {
      return;
    }
    this.initialized = true;
    this.settingsRepository.initialized$.subscribe(() => {
      const show = this.getShowPlannerOnBoarding();
      this.setShowPlannerOnBoarding(show);
    });
  }

  public setShowPlannerOnBoarding(show: boolean): void {
    this.settingsRepository.setShowPlannerOnBoarding(show);
  }

  public getShowPlannerOnBoarding(): boolean {
    return this.settingsRepository.getShowPlannerOnBoarding();
  }
}
